<template>
    <b-badge v-if="label" :variant="variant" class="m-0">
        {{ label }}
    </b-badge>
</template>

<script>
import { UserTaskStatus, taskStatusLabel } from '@/models/UserTask';

const VARIANTS = {
    [UserTaskStatus.new]: 'info',
    [UserTaskStatus.inProgress]: 'primary',
    [UserTaskStatus.complete]: 'success',
    [UserTaskStatus.expired]: 'warning',
    [UserTaskStatus.cancelled]: 'danger',
};

export default {
    name: "TaskStatusBadge",
    props: {
        value: UserTaskStatus
    },
    computed: {
        // Text comes from the shared helper so the History page and this badge cannot drift apart.
        label() {
            return taskStatusLabel(this.value);
        },
        variant() {
            return VARIANTS[this.value];
        }
    }
}
</script>
